/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { applyPolyfills, defineCustomElements } from '@ion-phaser/core/loader';
applyPolyfills().then(() => defineCustomElements());
export const IonPhaser = /*@__PURE__*/ createReactComponent('ion-phaser');
//# sourceMappingURL=components.js.map